// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"yba-z","colorTextValue":"zba-z","swatches":"Aba-z","collapseLink":"Bba-z","isCollapsed":"Cba-z","dropdown":"Dba-z","disabled":"Eba-z"};